var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "list", attrs: { id: "list" } },
    [
      _c("div", { staticClass: "l-center" }, [
        _c("h2", { staticClass: "title" }),
        _c("div", { ref: "swiper", staticClass: "swiper" }, [
          _c(
            "div",
            {
              staticClass: "swiper-wrapper",
              on: {
                "!click": function ($event) {
                  return _vm.preview("open")
                },
              },
            },
            _vm._l(_vm.imgList, function (src, idx) {
              return _c("div", { key: idx, staticClass: "swiper-slide" }, [
                _c("img", { attrs: { src: src, alt: "" } }),
              ])
            }),
            0
          ),
          _c("div", { ref: "prev", staticClass: "swiper-button-prev" }),
          _c("div", { ref: "next", staticClass: "swiper-button-next" }),
          _c("div", { ref: "pagination", staticClass: "swiper-pagination" }),
        ]),
      ]),
      _c("div", { staticClass: "modal" }),
      _c("DlgPerview", {
        attrs: { visible: _vm.visible, src: _vm.src },
        on: {
          close: function ($event) {
            return _vm.preview("close")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }